import { CreatePlacedItemBackLog, RemoveFromBackLog } from "../../Game/BackSystems.js";
import { ReturnToTray } from "./ReturnToTray.js";
import {TintReturn} from "./TintReturn.js"

export function TreeTopClickHandler()
{
    const Scene = this.scene;

    if(!Scene.ActiveTreeTop)
    {
        Scene.AudioChan.Chan1.play('pick_up_ornament');
        const LocationVector = _PrepareGeneralLocation(Scene,this.height);
        Scene.ActiveTreeTop = Scene.addImage(LocationVector.x,LocationVector.y,this.frame.name);

        Scene.ActiveTreeTop.setData('AssetType','TreeTop');
        CreatePlacedItemBackLog(Scene.ActiveTreeTop,'Created');
        OnCreateNewTreeTop(Scene);
    }
    else if(Scene.ActiveTreeTop.frame.name != this.frame.name && Scene.ActiveTreeTop.active === true)
    {
        Scene.AudioChan.Chan1.play('pick_up_ornament');
        const LocationVector = _PrepareGeneralLocation(Scene,this.height);
        let OldTop = {PreviousFrameName: Scene.ActiveTreeTop.frame.name};

        if(Scene.ActiveTreeTop.isTinted)
        {
            OldTop.Tint = TintReturn(Scene.ActiveTreeTop.tintTopRight);
        }

        if(!this.isTinted)
        {
            Scene.ActiveTreeTop.clearTint();
        }

        Scene.ActiveTreeTop.setFrame(this.frame.name);
        Scene.ActiveTreeTop.setPosition(LocationVector.x,LocationVector.y);

        //Scene.ActiveTreeTop.destroy();
        // Scene.ActiveTreeTop = Scene.addImage(LocationVector.x,LocationVector.y,this.frame.name);
        CreatePlacedItemBackLog(Scene.ActiveTreeTop,'Swapped',OldTop);
        // OnCreateNewTreeTop(Scene);
    }
    else if(!Scene.ActiveTreeTop.active)
    {
        Scene.AudioChan.Chan1.play('pick_up_ornament');
        const LocationVector = _PrepareGeneralLocation(Scene,this.height);

        Scene.ActiveTreeTop = Scene.addImage(LocationVector.x,LocationVector.y,this.frame.name);

        Scene.ActiveTreeTop.setData('AssetType','TreeTop');
        CreatePlacedItemBackLog(Scene.ActiveTreeTop,'Created');
        OnCreateNewTreeTop(Scene);
    }

    if(this.isTinted && Scene.ActiveTreeTop.tintTopRight != this.tintTopRight)
    {
        if(!Scene.AudioChan.Chan1.isPlaying)Scene.AudioChan.Chan1.play('pick_up_ornament');
        Scene.ActiveTreeTop.setTint(TintReturn(this.tintTopRight));
    }
    
}

function _SetDragRules(TreeTop)
{
    var DragStart = new Phaser.Math.Vector2;
    var OldLocation = new Phaser.Math.Vector2;

    TreeTop.on('dragstart',(Pointer)=>{
        DragStart.setFromObject(Pointer);
        OldLocation.setFromObject(TreeTop);
        //console.log(TreeTop.scene);
        //console.log(TreeTop.scene.input);
    });
    TreeTop.on('drag',(Pointer)=>{
        //console.log(TreeTop.scene.input._drag);
        if (Phaser.Math.Distance.BetweenPoints(DragStart, Pointer) > 200)
        {
            RemoveFromBackLog(TreeTop.scene,TreeTop);
            ReturnToTray(TreeTop);
        }
    });
    TreeTop.on('dragend',()=>{
        TreeTop.setPosition(OldLocation.x,OldLocation.y);
    });
}

function _PrepareGeneralLocation(Scene,ClickedTreeTopHeight)
{
        const PlacePoint = Scene.ActiveTree.getTopCenter();
        var Ylocation = PlacePoint.y - (ClickedTreeTopHeight*.25)+10;
        var Xlocation = PlacePoint.x+1;
        
        if(Scene.ActiveTree.frame.name === "Tree_FlufBG")
        {
            Xlocation += 11;
            Ylocation += 12;   
        }

        else if(Scene.ActiveTree.frame.name === "Tree_PntyBG")
        {
            Ylocation += 26;
            Xlocation += 3;
        }

        else
        {
            Ylocation += 12;
            Xlocation += 1;
        }

        const returnValue = new Phaser.Math.Vector2(Xlocation,Ylocation);

        return returnValue;
}

export function OnCreateNewTreeTop(Scene)
{
    Scene.ActiveTreeTop.setInteractive();
    Scene.input.setDraggable(Scene.ActiveTreeTop);
    Scene.ActiveTreeTop.setDepth(Scene.DepthList.TreeItems);

    _SetDragRules(Scene.ActiveTreeTop);
}